import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: {},
    errorMessage: '',
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.PDF_TOOL_FETCH:
      return state.merge(reduxHelper.applyRequestInfo());
    case types.PDF_TOOL_FETCH_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: action.payload,
        })
      );
    case types.PDF_TOOL_FETCH_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    case types.PDF_TOOL_CLEAR:
      return state.merge({ ...initialState.toJS() });
    default:
      return state;
  }
}
